import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import ABAWDDetails from '../../subdepartmentdetails/ABAWD'


function ABAWD() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Able-Bodied Adults Without Dependents and Mandatory Work Participants || SNAP";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="SNAP"
            title="Able-Bodied Adults Without Dependents and Mandatory Work Participants"
            subtitledown="Department of Family & Children Services"
           />
            <ABAWDDetails/>
        </div>
    </>
  )
}

export default ABAWD



